import { userConstants } from "../constants/login.constants";

 function businessNameWelcomeReport(state = {}, action) {
    switch (action.type) {
        case userConstants.BUSINESSWELCOMEREPORT_REQUEST:
            return {
                loading: true
            };
        case userConstants.BUSINESSWELCOMEREPORT_SUCCESS:
            return {
                items: action.businessNameWelcomeReport
            };
        case userConstants.BUSINESSWELCOMEREPORT_FAILURE:
            return {
                error: action.error
            };
        default:
            return state
    }
}
export default businessNameWelcomeReport;